import React from 'react';
import { compose } from 'ramda';
import { Button, Input } from '@deeptrue-frontend/ui';
import { Formik, Form, Field as FormikField, FormikHelpers } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { BusinessSectorType } from 'store/modules/assistant/assistant';
import { businessSectorsToSelect } from 'store/modules/assistant/utils';
import Fields from 'components/Fields';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import IntlProvider, {
  useFormatMessage,
  IntlProviderType,
} from 'components/IntlProvider';

const { connect } = StoreProvider;

const useStyles = makeStyles((theme) => ({
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export type SubmitHandler = (
  values: any,
  formHelpers: FormikHelpers<any>
) => void;

interface OrganizationProps {
  onSubmit: SubmitHandler;
  initialValues: {
    isAdmin: boolean;
    business_sectors: BusinessSectorType[];
    logo: any;
  };
  submitError?: string;
  intl: IntlProviderType;
}

const Organization = ({ onSubmit, initialValues }: OrganizationProps) => {
  const classes = useStyles();
  const t = useFormatMessage();
  return (
    <Grid item xs={12} md={7}>
      <Formik onSubmit={onSubmit} initialValues={initialValues} noValidate>
        {({ touched, isSubmitting, errors }) => (
          <Form className={classes.form}>
            <FormikField
              name="name"
              as={Input}
              hasError={touched.normal && errors.normal}
              helperText={touched.normal && errors.normal}
              label={t('forms.organization.name', 'Organization name')}
            />
            <Fields.BusinessSectors
              disabled={!initialValues.isAdmin}
              sectors={initialValues.business_sectors}
            />
            {typeof initialValues.logo === 'string' && (
              <img
                alt="organization logo"
                src={initialValues.logo}
                style={{ width: '200px', height: 'auto' }}
              />
            )}
            <FormikField
              name="logo"
              component={Fields.File}
              type="file"
              label={t('forms.organization.icon', 'Organization icon')}
            />
            {initialValues.isAdmin && (
              <Button
                mt="2rem"
                width="100%"
                height="3rem"
                type="submit"
                disabled={isSubmitting}
                isLoading={isSubmitting}
              >
                {t('forms.profile.save', 'Save')}
              </Button>
            )}
          </Form>
        )}
      </Formik>
    </Grid>
  );
};

export default compose(
  IntlProvider.withIntl,
  connect((state, props: OrganizationProps) => ({
    initialValues: {
      ...props.initialValues,
      business_sectors: businessSectorsToSelect(
        props.initialValues.business_sectors,
        props.intl.locale
      ),
    },
  }))
)(Organization);
